import React from 'react';
import StartingHandChart from './StartingHandChart';
import MediaQuery from 'react-responsive';
import { apiService } from '../../common/apiCallService';
import { processHoleCards, getCorlorCodForGrade, saveActivity } from '../../common/commonService'
import { domain, baseUrl as restApiUrl } from '../../common/config.js';
import Loading from '../Loading';
import AdviceComponent from './AdviceComponent';
import './adviceComponent.css'
import StartingHandBase from './StartingHandBase';
import PreFlopAggressionBase from './PreFlopAggressionBase';
import { getColor, getTextColor } from '../../common/ThemeService';

const charts = [{ type: 'ideal', datae2e: 'idealVal' }, { type: 'actual', datae2e: 'actualVal' }]
const positions = [{ type: 'Early', datae2e: 'earlyPos' }, { type: 'Late', datae2e: 'latePos' }]
const baseUrl = "//" + domain;

class StartHandsOrAggression extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hands: {},
            loading: true,
            play: localStorage.getItem('play') || 'actual',
            position: 'Early',
            holeCards: [],
            greenHands: 0,
            redHands: 0,
            missionHands: [],
            preFlopAggression: props.preFlopAggression ? props.preFlopAggression : false,
            isHandsAvailable: false,
        }
        localStorage.removeItem('play');
    }

    async componentWillReceiveProps(newProps) {
        if (newProps.preFlopAggression !== this.props.preFlopAggression || newProps.gameType !== this.props.gameType) {
            await this.getStartingHands()
            this.getHoleCards(newProps.preFlopAggression);
        }
    }

    componentDidMount = async () => {
        await this.getStartingHands()
        this.getHoleCards(this.props.preFlopAggression);
    }

    getStartingHands = () => new Promise((resolve, reject) => {
        this.setState({ loading: true })
        apiService(restApiUrl + '/appUser/getStartingHands', {
            "Strategy": '6-seater',
            accountName: localStorage.getItem('accountName')
        }, (data) => {
            let hand = {}
            hand['Early'] = data[0]['Early']
            hand['Late'] = data[0]['Late']
            hand['Mid'] = data[0]['Mid']
            this.setState({ hands: hand })
            this.setState({ loading: false })
            resolve()
        }, (err) => {
            console.log("ERROR:", err)
            this.setState({ loading: false })
            reject()
        })
    })

    getHoleCards = (preFlopAggression) => new Promise((resolve, reject) => {
        this.setState({ loading: true, isHandsAvailable: false })
        let { ringType, gameType } = this.props
        const req = { 'ringType': ringType };
        if (preFlopAggression)
            req['preFlopAggression'] = true;
        apiService(restApiUrl + '/missions/getMissionRecords', {
            'accountName': localStorage.getItem('accountName'),
            'selectedType': ringType ,
            'startDate': this.state.missionstartDate,
            'userType': localStorage.getItem('loggedInType'),
            'gameType': gameType === "spin" ? "Spin" : gameType,
            ...req
        }, async (plydata) => {
            if (plydata && plydata.length > 0) {
                this.setState({ isHandsAvailable: true })
                let redHands = 0
                    , greenHands = 0
                    , totalHands = 0
                    , progressplayed = 0,
                    missionHands = [];
                if (this.props.preFlopAggression) {
                    plydata.forEach((handObj) => {
                        if (handObj.raised === 1) {
                            greenHands = greenHands + 1
                        }
                        if (handObj.limp === 1) {
                            redHands = redHands + 1
                        }
                    })
                    totalHands = greenHands + redHands;
                    missionHands = plydata;
                } else if (this.state.hands && Object.keys(this.state.hands).length > 0) {
                    const tableData = await processHoleCards(plydata, this.state.hands, ringType, this.state.position);
                    let handCount = tableData[0];
                    Object.keys(handCount).forEach((key) => {
                        greenHands += handCount[key].played + handCount[key].progressplayed
                        redHands += handCount[key].notPlayed
                    });
                    totalHands = redHands + greenHands + progressplayed
                    this.setState({ handCount: tableData[0] })
                    this.setState({ holeCards: tableData[1] })
                    this.setState({ playerData: tableData[2] })
                }
                this.setState({ progressplayed, greenHands, redHands, totalHands, missionHands })
                this.setState({ loading: false })
            } else {
                this.setState({ handCount: 0, redHands: 0, greenHands: 0 })
                this.setState({ holeCards: [] })
                this.setState({ missionHands: [] })
                this.setState({ playerData: {} })
            }
            this.setState({ loading: false })
        }, (data) => {
            this.setState({ loading: false })
        })
    });

    learnMoreTrackingStartingHand = () => {
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = "ClickStartingHandsTabLearnAboutPosition";
        track.hit_attribute1 = this.props.gameType;
        saveActivity(track);
    }

    onSelectChartOrPosition = (optionSelected, chartOrPos) => {
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = this.props.preFlopAggression
            ? "ClickAggressionTabAdvisedActual"
            : (chartOrPos === "play" ? "ClickStartingHandsTabAdvisedActual" : "ClickStartingHandsTabPosition");
        track.hit_attribute1 = this.props.gameType;
        track.hit_attribute2 = chartOrPos === "play"
            ? (optionSelected === 'ideal' ? "ADVISED" : optionSelected.toUpperCase())
            : optionSelected.toUpperCase();
        saveActivity(track);

        this.setState({ selected: true, [chartOrPos]: optionSelected })
        if (this.state[chartOrPos] === optionSelected || this.props.preFlopAggression) {
            return;
        }
        if (optionSelected == 'actual' && !this.state.holeCards) {
            this.getHoleCards(this.props.preFlopAggression);
        } else if (!this.props.preFlopAggression && this.state.holeCards) {
            let redHands = 0
                , greenHands = 0
                , totalHands = 0
                , progressplayed = 0
                , position = ['Early', 'Late'].indexOf(optionSelected) != -1 ? optionSelected : this.state.position
                , handCount = this.state.handCount
                , holeCards = this.state.playerData.reduce((acc, obj) => {
                    if (obj.playerPosition == position) acc.push(obj)
                    return acc
                }, [])

            Object.keys(handCount).forEach((key) => {
                greenHands = greenHands + handCount[key].played
                redHands = redHands + handCount[key].notPlayed
                progressplayed = progressplayed + handCount[key].progressplayed
            });
            totalHands = redHands + greenHands + progressplayed
            this.setState({ progressplayed, greenHands, redHands, holeCards, totalHands })
        }
    }

    //A - 95-100 B 80 -94 C 60 - 79 d 45 - 59 e below 45
    getGrade = (val) => {
        let grade = 'E';
        if (val >= 95 && val <= 100) {
            grade = 'A';
        } else if (val >= 80 && val <= 94.9) {
            grade = 'B';
        } else if (val >= 60 && val <= 79.9) {
            grade = 'C';
        } else if (val >= 45 && val <= 59.9) {
            grade = 'D';
        }
        return { grade, color: getCorlorCodForGrade(grade) };
    }

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        const { preFlopAggression } = this.props,
            { hands, holeCards, position, play, redHands, greenHands, totalHands, missionHands, loading } = this.state,
            greenHandStatus = preFlopAggression ? { status: '% raised (Optimal 72-89%)', color: 'blue' } : { status: '% raised correctly', color: 'green' },
            redHandStatus = preFlopAggression ? { status: '% Limped or Called', color: 'yellow' } : { status: '% raised incorrectly', color: 'red' },
            gradeData = this.getGrade(parseInt(totalHands) > 0 ? ((greenHands / totalHands) * 100).toFixed(2) : 0),
            playDetails = [{ type: 'play', handStatus: greenHandStatus, content: charts, hand: greenHands },
            { type: 'position', handStatus: redHandStatus, content: preFlopAggression ? [] : positions, hand: redHands }];
        console.log("preFlopAggression",preFlopAggression);
            return (
            <div>
                {loading && <Loading />}
                <div className='base_home_observations_body'>
                    <div className="mobile_starting_hand_positions">
                        <div className="mobile_starting_hand_chart_position">
                            <div className="positions span">Hand Chart</div>
                            <div className="positions" >
                                <span className="play">
                                    {charts.map((eachPlay, index) =>
                                        <div data-e2e={eachPlay.datae2e} key={index} className={`normalTextSize defplaybtns ptr ${this.state.play === eachPlay.type && 'activePlaybtn'}`}
                                            style={this.state.play === eachPlay.type ?
                                                {
                                                    backgroundColor: themeColor,
                                                    color: themeTextColor,
                                                }
                                                : {}}
                                            onClick={() => this.onSelectChartOrPosition(eachPlay.type, 'play')}>{eachPlay.type == 'ideal' ? "ADVISED" : eachPlay.type.toUpperCase()}</div>
                                    )}
                                </span>
                            </div>
                        </div>
                        {!preFlopAggression && <div className="mobile_starting_hand_chart_position">
                            <div className="positions span">Positions</div>
                            <div className="positions">
                                <span className="play">
                                    {positions.map((eachPosition, index) =>
                                        <div data-e2e={eachPosition.datae2e} key={index} className={`normalTextSize defplaybtns ptr ${this.state.position === eachPosition.type && 'activePlaybtn'}`}
                                            style={this.state.position === eachPosition.type ?
                                                {
                                                    backgroundColor: themeColor,
                                                    color: themeTextColor,
                                                }
                                                : {}}
                                            onClick={() => this.onSelectChartOrPosition(eachPosition.type, 'position')}>{eachPosition.type.toUpperCase()}</div>
                                    )}
                                </span>
                            </div>
                        </div>}
                    </div>
                    <div className="landingPageHoleCardsChart" >
                        {preFlopAggression && play === "ideal" ?
                            <AdviceComponent gameType={this.props.gameType} baseUrlImg={baseUrl} className="chart-width" />
                            : Object.keys(hands).length > 0 &&
                            <StartingHandChart
                                Loading={Loading}
                                hands={hands}
                                position={position}
                                play={play}
                                loading={loading}
                                holeCards={holeCards}
                                missionHands={missionHands}
                                handCount={this.state.handCount}
                                totalHandPlayed={this.props.totalHandPlayed === 0 ? this.state.totalHands : this.props.totalHandPlayed}
                                preFlopAggression={preFlopAggression}
                            />
                        }
                    </div>
                    <div className="starting_hands_main_div">
                        <div className="starting_hands_sub_div">
                            <div className="positions observationType"> {preFlopAggression ? 'Pre-Flop Aggression' : 'Starting Hands'}
                                {totalHands > 0 ?
                                    <span className="positions observationType grade_div">
                                        Grade: &nbsp;<span className='landingPageObsCursive' style={{ color: gradeData.color }}>{gradeData.grade}</span>
                                    </span>
                                    :
                                    <span className="positions observationType grade_div">
                                        Grade will appear here
                                    </span>
                                }
                            </div>

                            <div className="observationHeading">
                                {playDetails.map((obj, index) =>
                                    <PlayDetails
                                        play={play}
                                        position={position}
                                        contentList={obj.content}
                                        totalHands={totalHands}
                                        handStatus={obj.handStatus}
                                        preFlopAggression={preFlopAggression}
                                        btnType={obj.type}
                                        onSelectChartOrPosition={this.onSelectChartOrPosition}
                                        handPlayed={parseInt(obj.hand) > 0 ? ((obj.hand / totalHands) * 100).toFixed(2) : 0}
                                        key={index}
                                    />)}
                            </div>
                        </div>
                        {preFlopAggression === true ?
                            <ul className="description_points" style={{ marginBottom: this.state.play === 'ideal' ? '65px' : '25px' }}>
                                <li>Playing too passively is a common mistake, if you enter a pot try to be the aggressor.</li>
                                <li>You need to be entering pots as the raiser around 3 times as often as you call / limp.</li>
                                <li>Blue is where you raised correctly & Yellow is where you limp or call.</li>
                                <li>Last 48hr’s <span className="blue" style={{ backgroundColor: "#ffffff" }}>Raises</span> & <span className="yellow" style={{ backgroundColor: "#ffffff" }}>Calls</span> in the Actual chart.</li>
                            </ul>
                            :
                            <ul className="description_points" >
                                <li>Playing the wrong hands is the biggest beginner mistake. Fix this & see massive gains!</li>
                                <li>The <b><a href="javascript:void(0)" onClick={() => this.onSelectChartOrPosition('ideal', 'play')}>Advised</a></b> play charts show when to <b>raise unopened pots</b> in early & late position.</li>
                                <li>Keep your <b><a href="javascript:void(0)" onClick={() => this.onSelectChartOrPosition('actual', 'play')}>Actual</a></b> play in the green & watch your game improve.</li>
                                <li>Last 48hr’s Starting Hands in the Actual Charts.</li>
                            </ul>
                        }
                        {preFlopAggression === true
                            ? <PreFlopAggressionBase
                                isHandsAvailable={this.state.isHandsAvailable}
                                gameType={this.props.gameType}
                                learnMore={this.props.learnMore}
                                seeMoreHands={this.props.seeMoreHands} />
                            : <StartingHandBase
                                play={this.state.play}
                                gameType={this.props.gameType}
                                learnMoreTrackingStartingHand={this.learnMoreTrackingStartingHand}
                                isHandsAvailable={this.state.isHandsAvailable}
                                seeMoreHands={this.props.seeMoreHands} />
                        }

                    </div>
                </div>
            </div>
        )
    }
}


const PlayDetails = props => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const { contentList, play, handPlayed, handStatus, position, preFlopAggression, btnType } = props
    return (
        <div className="positionType" >
            <MediaQuery minWidth={767} >
                {contentList.length > 0 && <span className="play">
                    {contentList.map((eachPlay, index) =>
                        <div data-e2e={eachPlay.datae2e} key={btnType + eachPlay.type} className={`normalTextSize defplaybtns ptr ${[play, position].includes(eachPlay.type) && 'activePlaybtn'}`}
                            style={[play, position].includes(eachPlay.type) ?
                                {
                                    backgroundColor: themeColor,
                                    color: themeTextColor,
                                }
                                : {}}
                            onClick={() => props.onSelectChartOrPosition(eachPlay.type, btnType)}>{eachPlay.type == 'ideal' ? "ADVISED" : eachPlay.type.toUpperCase()}</div>
                    )}
                </span>}
            </MediaQuery>
            {play !== 'ideal' &&
                <div className={`landingPageChartStatus ${preFlopAggression && 'landingPageChartStatusAgg'}`}>
                    <span className={`rectangle bg-clr-${handStatus.color}`}></span>
                    <span className='status-txt'>{(handPlayed < 10) ? ("0" + handPlayed) : handPlayed}{handStatus.status.split('(').map((status, i) => i < 1 ? status : <span key={'status-' + i} className='status-subText'>({status}</span>)}</span>
                </div>}
        </div>
    )
}
export default StartHandsOrAggression;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/StartHandsOrAggression.js
 **/